export enum ChargeMethod
{
    NotAvailable = 0,
    DeGrazieWallet = 1000,
    Cash = 2000,
    TicketRestaurantMobile = 3000,
    MbWay = 4000,
    CreditCard = 5000,
    PaymentTerminal = 6000,
}